// extracted by mini-css-extract-plugin
export default {"error":"QNKi_Ck4eewd7WLrvxjq"};